/* Supra product page: gallery, options, picture picker, price, quantity, sticky add to cart bar and related products. Add to cart goes through Horizon's product-form-component. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  function setLabel(button, text) {
    for (var i = 0; i < button.childNodes.length; i++) {
      var node = button.childNodes[i];
      if (node.nodeType === 3 && node.textContent.trim()) {
        node.textContent = text;
        return;
      }
    }
  }

  if (!customElements.get('sg-product')) {
    class SgProduct extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sg-slides]');
        this.slides = this.track ? Array.prototype.slice.call(this.track.children) : [];
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-sg-thumb]'));
        this.form = this.querySelector('form');
        this.idInput = this.form ? this.form.querySelector('input[name=id]') : null;
        this.button = this.form ? this.form.querySelector('button[type=submit]') : null;
        this.qty = this.form ? this.form.querySelector('input[name=quantity]') : null;
        this.priceNode = this.querySelector('[data-sg-price]');
        this.skuNode = this.querySelector('[data-sg-sku]');
        this.noteNode = this.querySelector('[data-sg-note]');
        this.groups = this.querySelectorAll('[data-sg-option]');
        this.grouped = this.slides.some(function (s) { return s.hasAttribute('data-sg-group'); });
        this.variants = [];

        var data = this.querySelector('script[data-sg-variants]');
        if (data) {
          try {
            this.variants = JSON.parse(data.textContent);
          } catch (e) {}
        }

        var self = this;
        for (var g = 0; g < this.groups.length; g++) {
          this.groups[g].addEventListener('change', function () {
            self.apply();
          });
        }
        for (var t = 0; t < this.thumbs.length; t++) {
          this.thumbs[t].addEventListener('click', function (event) {
            var index = parseInt(event.currentTarget.getAttribute('data-sg-thumb'), 10) || 0;
            self.goTo(index);
          });
        }
        var steppers = this.querySelectorAll('[data-sg-qty]');
        for (var s = 0; s < steppers.length; s++) {
          steppers[s].addEventListener('click', function (event) {
            if (!self.qty) return;
            var step = parseInt(event.currentTarget.getAttribute('data-sg-qty'), 10) || 0;
            var next = (parseInt(self.qty.value, 10) || 1) + step;
            self.qty.value = String(Math.max(1, Math.min(99, next)));
          });
        }

        if (this.track) {
          this.ticking = false;
          this.track.addEventListener('scroll', function () {
            if (self.ticking) return;
            self.ticking = true;
            window.requestAnimationFrame(function () {
              self.ticking = false;
              self.markThumb();
            });
          });
        }
        this.dotsBox = this.querySelector('[data-sg-dots]');
        this.countNode = this.querySelector('[data-sg-count]');
        this.glow = this.querySelector('.sg-stage__glow');
        var steps = this.querySelectorAll('[data-sg-step]');
        for (var k = 0; k < steps.length; k++) {
          steps[k].addEventListener('click', function (event) {
            self.step(parseInt(event.currentTarget.getAttribute('data-sg-step'), 10) || 1);
          });
        }
        var zoom = this.querySelector('[data-sg-zoom]');
        if (zoom) zoom.addEventListener('click', function () { self.openLightbox(); });
        if (this.track) {
          this.track.addEventListener('click', function (event) {
            if (event.target.closest('.sg-pdp__slide')) self.openLightbox();
          });
        }
        var picks = this.querySelectorAll('[data-sg-pick]');
        for (var q = 0; q < picks.length; q++) {
          picks[q].addEventListener('click', function (event) {
            self.pick(event.currentTarget.getAttribute('data-sg-pick'));
          });
        }
        this.lb = this.querySelector('[data-sg-lb]');
        if (this.lb) {
          var closeBtn = this.lb.querySelector('[data-sg-lb-close]');
          if (closeBtn) closeBtn.addEventListener('click', function () { self.lb.close(); });
          this.lb.addEventListener('click', function (event) {
            if (event.target === self.lb || event.target.tagName === 'FIGURE') self.lb.close();
          });
        }
        try {
          var dflt = this.querySelector('script[data-sg-thumb-default]');
          this.defaultThumb = dflt ? JSON.parse(dflt.textContent) : '';
        } catch (e) {
          this.defaultThumb = '';
        }

        this.buildDots();
        this.markThumb();
        this.buildBar();
      }

      buildDots() {
        if (!this.dotsBox) return;
        this.dotsBox.textContent = '';
        var shown = this.visible();
        if (shown.length < 2) return;
        for (var i = 0; i < shown.length; i++) this.dotsBox.appendChild(document.createElement('span'));
      }

      currentIndex() {
        if (!this.track) return 0;
        var width = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / width);
      }

      step(dir) {
        var shown = this.visible();
        if (!shown.length) return;
        var next = (this.currentIndex() + dir + shown.length) % shown.length;
        this.goTo(this.slides.indexOf(shown[next]));
      }

      openLightbox() {
        if (!this.lb || typeof this.lb.showModal !== 'function') return;
        var track = this.lb.querySelector('[data-sg-lb-track]');
        var shown = this.visible();
        track.textContent = '';
        for (var i = 0; i < shown.length; i++) {
          var src = shown[i].getAttribute('data-full');
          if (!src) continue;
          var fig = document.createElement('figure');
          var img = document.createElement('img');
          img.src = src;
          img.alt = (shown[i].querySelector('img') || {}).alt || '';
          img.loading = 'lazy';
          fig.appendChild(img);
          track.appendChild(fig);
        }
        var at = this.currentIndex();
        this.lb.showModal();
        track.scrollLeft = track.clientWidth * at;
      }

      pick(value) {
        var group = this.groups[0];
        if (!group) return;
        var inputs = group.querySelectorAll('input[type=radio]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value) {
            inputs[i].checked = true;
            inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
        var top = this.querySelector('.sg-pdp__grid');
        if (top) top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.bar && this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
        root.classList.remove('sg-atc-bar');
      }

      /* Sticky add to cart bar for phones and tablets, shown once the main button has scrolled out of view */
      buildBar() {
        var row = this.querySelector('.sg-pdp__row');
        var title = this.querySelector('.sg-pdp__title');
        if (!row || !this.button || !title || !('IntersectionObserver' in window)) return;

        var bar = document.createElement('div');
        bar.className = 'sg-atc sg-atc--v2';
        bar.inert = true;

        this.barThumb = document.createElement('img');
        this.barThumb.className = 'sg-atc__thumb';
        this.barThumb.alt = '';
        this.barThumb.width = 48;
        this.barThumb.height = 48;
        bar.appendChild(this.barThumb);

        var info = document.createElement('div');
        info.className = 'sg-atc__info';
        this.barTitle = document.createElement('span');
        this.barTitle.className = 'sg-atc__title';
        this.barTitle.textContent = title.textContent.trim();
        this.barPrice = document.createElement('span');
        this.barPrice.className = 'sg-atc__price';
        info.appendChild(this.barTitle);
        info.appendChild(this.barPrice);

        this.barButton = document.createElement('button');
        this.barButton.type = 'button';
        this.barButton.className = 'sg-btn sg-atc__btn';

        bar.appendChild(info);
        bar.appendChild(this.barButton);
        document.body.appendChild(bar);
        this.bar = bar;

        var self = this;
        this.barButton.addEventListener('click', function () {
          if (self.button && !self.button.disabled) self.button.click();
        });

        this.observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', show);
          bar.inert = !show;
          root.classList.toggle('sg-atc-bar', show);
        });
        this.observer.observe(row);

        /* Keep the bar in step when the main button changes label after adding */
        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            self.syncBar();
          }).observe(this.button, { childList: true, subtree: true, characterData: true, attributes: true });
        }
        this.syncBar();
      }

      syncBar() {
        if (!this.bar) return;
        var priceEl = this.priceNode ? this.priceNode.lastElementChild : null;
        var picked = this.selection().filter(function (v) { return v && v !== 'Default Title'; }).join(', ');
        var price = priceEl ? priceEl.textContent : '';
        this.barPrice.textContent = picked ? picked + ' · ' + price : price;
        var variant = this.match(this.selection());
        var thumb = (variant && variant.thumb) || this.defaultThumb;
        if (thumb && this.barThumb.getAttribute('src') !== thumb) this.barThumb.src = thumb;
        this.barThumb.hidden = !thumb;
        this.barButton.textContent = (this.button.textContent || 'Add to cart').trim() || 'Add to cart';
        this.barButton.disabled = this.button.disabled;
      }

      selection() {
        var values = [];
        for (var i = 0; i < this.groups.length; i++) {
          var checked = this.groups[i].querySelector('input:checked');
          values.push(checked ? checked.value : null);
        }
        return values;
      }

      match(values) {
        for (var i = 0; i < this.variants.length; i++) {
          var ok = true;
          for (var j = 0; j < values.length; j++) {
            if (this.variants[i].options[j] !== values[j]) {
              ok = false;
              break;
            }
          }
          if (ok) return this.variants[i];
        }
        return null;
      }

      visible() {
        return this.slides.filter(function (s) { return !s.hidden; });
      }

      goTo(index, instant) {
        if (!this.track || !this.slides[index]) return;
        this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior: reduce || instant ? 'auto' : 'smooth' });
      }

      markThumb() {
        if (!this.track) return;
        var width = this.track.clientWidth || 1;
        var shown = this.visible();
        var target = shown[Math.round(this.track.scrollLeft / width)];
        var index = this.slides.indexOf(target);
        for (var i = 0; i < this.thumbs.length; i++) {
          if (parseInt(this.thumbs[i].getAttribute('data-sg-thumb'), 10) === index) this.thumbs[i].setAttribute('aria-current', 'true');
          else this.thumbs[i].removeAttribute('aria-current');
        }
        this.markStage(shown, shown.indexOf(target));
      }

      markStage(shown, at) {
        shown = shown || this.visible();
        if (at < 0) at = 0;
        if (this.countNode) this.countNode.textContent = shown.length > 1 ? (at + 1) + ' / ' + shown.length : '';
        if (this.dotsBox) {
          var dots = this.dotsBox.children;
          for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === at);
        }
        var slide = shown[at];
        if (this.glow && slide && slide.getAttribute('data-glow')) {
          var url = 'url(' + slide.getAttribute('data-glow') + ')';
          if (this.glow.style.backgroundImage !== url) this.glow.style.backgroundImage = url;
        }
      }

      /* Show the photos that belong to the picked value, plus the shared ones */
      showGroup(value) {
        if (!this.grouped) return false;
        var key = String(value || '');
        var first = -1;
        for (var i = 0; i < this.slides.length; i++) {
          var group = this.slides[i].getAttribute('data-sg-group');
          var hide = !!group && group !== key;
          this.slides[i].hidden = hide;
          if (!hide && group === key && first < 0) first = i;
        }
        for (var t = 0; t < this.thumbs.length; t++) {
          var tg = this.thumbs[t].getAttribute('data-sg-group');
          this.thumbs[t].hidden = !!tg && tg !== key;
        }
        if (first < 0) {
          var shown = this.visible();
          first = shown.length ? this.slides.indexOf(shown[0]) : 0;
        }
        var self = this;
        if (!reduce && this.track) {
          this.track.classList.add('is-swapping');
          window.setTimeout(function () { self.track.classList.remove('is-swapping'); }, 180);
        }
        this.buildDots();
        this.goTo(first, true);
        this.markThumb();
        var cards = this.querySelectorAll('[data-sg-pick]');
        for (var c = 0; c < cards.length; c++) cards[c].classList.toggle('is-on', cards[c].getAttribute('data-sg-pick') === key);
        return true;
      }

      apply() {
        if (!this.groups.length) return;
        var picked = this.selection();
        for (var p = 0; p < this.groups.length; p++) {
          var label = this.groups[p].querySelector('[data-sg-picked]');
          if (label && picked[p]) label.textContent = picked[p];
        }
        var variant = this.match(picked);

        if (!variant) {
          if (this.button) {
            this.button.disabled = true;
            setLabel(this.button, 'Unavailable');
          }
          if (this.noteNode) this.noteNode.textContent = 'This combination is not available.';
          this.syncBar();
          return;
        }

        if (this.idInput) this.idInput.value = variant.id;
        if (this.noteNode) this.noteNode.textContent = '';

        if (this.priceNode) {
          this.priceNode.textContent = '';
          if (variant.compare) {
            var old = document.createElement('s');
            old.textContent = variant.compare;
            this.priceNode.appendChild(old);
          }
          var now = document.createElement('span');
          now.textContent = variant.price;
          this.priceNode.appendChild(now);
        }
        var flowPrices = this.querySelectorAll('[data-sg-flow-price]');
        for (var fp = 0; fp < flowPrices.length; fp++) flowPrices[fp].textContent = variant.price;

        if (this.skuNode) this.skuNode.textContent = variant.sku ? 'SKU ' + variant.sku : '';

        if (this.button) {
          this.button.disabled = !variant.available;
          setLabel(this.button, variant.available ? 'Add to cart' : 'Sold out');
        }

        if (!this.showGroup(picked[0]) && variant.imageId) {
          for (var i = 0; i < this.slides.length; i++) {
            if (this.slides[i].getAttribute('data-image-id') === String(variant.imageId)) {
              this.goTo(i);
              break;
            }
          }
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}

        this.syncBar();
      }
    }
    customElements.define('sg-product', SgProduct);
  }

  if (!customElements.get('sg-recs')) {
    class SgRecs extends HTMLElement {
      connectedCallback() {
        var url = this.getAttribute('data-url');
        if (!url || this.hasAttribute('data-loaded')) return;
        this.setAttribute('data-loaded', '');
        var self = this;
        fetch(url)
          .then(function (response) {
            return response.ok ? response.text() : '';
          })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('sg-recs');
            if (fresh && fresh.innerHTML.trim()) {
              self.innerHTML = fresh.innerHTML;
            }
          })
          .catch(function () {});
      }
    }
    customElements.define('sg-recs', SgRecs);
  }
})();
